import type { Row } from "../byMonthTypes";

// What a channel's By Month draft changes against the published cells
// (Plan::ByMonth::DraftDiff), keyed by product external id and ISO month.
export interface ByMonthDiff {
  quantity_was: Record<string, Record<string, number | null>>;
  summary: {
    changed_quantities: number;
    changed_products: number;
    any_changes: boolean;
  };
}

// The number on the review page's "Plan changes" tab: one per changed cell.
// changed_products is how many rows those cells sit in, not a change itself.
export function monthlyChangeCount(summary: ByMonthDiff["summary"]): number {
  return summary.changed_quantities;
}

export function monthlySummaryText(summary: ByMonthDiff["summary"]): string {
  const n = summary.changed_quantities;
  if (n === 0) return "No changes against the published plan";
  const products = `${summary.changed_products} product${summary.changed_products === 1 ? "" : "s"}`;
  return `${n} ${n === 1 ? "quantity" : "quantities"} changed across ${products}`;
}

export function rowChanged(row: Row, diff: ByMonthDiff): boolean {
  return row.product_external_id in diff.quantity_was;
}
